import { __generator } from "tslib";
import { put, takeLatest, select } from 'redux-saga/effects';
import { getCurrentPageItems } from './selectors';
import { STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE, fetch } from './actions';
function onNextPage(action) {
    var streamId, currentPageItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, select(function (state) {
                        return getCurrentPageItems(state, streamId);
                    })];
            case 1:
                currentPageItems = _a.sent();
                if (!!currentPageItems.length) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetch(streamId))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE, onNextPage)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default saga;
//# sourceMappingURL=saga.js.map